/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { LogoFragment } from "@cosmos/hygraph-schema";

import { CosmosImage, CosmosLink } from "@components/elements";
import { css, cx } from "@panda/css";

import { useHygraphLogoUrl } from "./LogoMarquee.util";

const logoStyles = css({
	h: "full",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	"&.landscape .logo-wrap": {
		height: "66.66%",
	},
});

const wrapStyles = css({
	h: "full",
	"& > a, & img": {
		objectFit: "contain",
		h: "full",
		w: "auto",
	},
});

export interface LogoProps extends LogoFragment {
	height: number;
}

/**
 * Renders a logo image set to its parent height.  Maintains original aspect ratio.
 * When landscape, uses 2/3 height of parent.
 */
export const Logo = ({ image, height = 54, href, title, landscape }: LogoProps): React.JSX.Element => {
	const width = image?.width || 0;

	const url = useHygraphLogoUrl({ ...image, width, height });
	let imageEl = (
		<CosmosImage
			src={url}
			alt={title}
			width={width}
			height={height || image?.height || 0}
			unoptimized
			loading="eager"
		/>
	);

	if (href) {
		imageEl = (
			<CosmosLink
				href={href}
				analytics={{
					eventCategory: "hyperlink",
					eventLabel: title || "",
					eventValue: {
						component: "Logo",
						href,
						image: image.url,
					},
				}}
			>
				{imageEl}
			</CosmosLink>
		);
	}

	return (
		<div className={cx("logo", landscape ? "landscape" : "default", logoStyles)}>
			<div className={`logo-wrap ${wrapStyles}`}>{imageEl}</div>
		</div>
	);
};
